import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./index.css";
import "./App.css";
import mqtt from "mqtt";

// Expose mqtt globally for legacy scripts (e.g. jsCallWidget.js)
window.mqtt = mqtt;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
